<template>
  <div>
    <head-nav-bar
      title="订单管理"
      :fixed="true"
      rightText="筛选"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder="订单号/桌台号"
        style="border-bottom:1px solid #f1f1f1;"
        show-action
        shape="round"
        v-model="keyword"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <van-tabs
        v-model="tabName"
        :swipe-threshold="swipeThreshold"
        title-active-color="#098ae8"
        @change="changeTab"
      >
        <van-tab
          v-for="(item, index) in tabArr"
          :key="index"
          :title="item.title"
          :name="item.name"
        />
      </van-tabs>
      <div class="res-order-list">
        <DataList :api="getList" :params="params">
          <template v-slot:item="item">
            <div @click="orderDetail(item.Id)">
              <div style="display: flex; justify-content: space-between;">
                订单号：{{ item.No }}
                <van-tag color="#199ed8" v-if="item.Status == 0"
                  >{{ item.StatusName }}
                </van-tag>
                <van-tag v-else-if="item.Status == 1" color="#00cc99"
                  >{{ item.StatusName }}
                </van-tag>
                <van-tag v-else-if="item.Status == 2" color="#fc0"
                  >{{ item.StatusName }}
                </van-tag>
                <van-tag v-else-if="item.Status == 12" color="#f60"
                  >{{ item.StatusName }}
                </van-tag>
                <van-tag v-else-if="item.Status == 4" color="#f00"
                  >{{ item.StatusName }}
                </van-tag>
                <van-tag v-else color="#999">{{ item.StatusName }} </van-tag>
              </div>
              <van-row>
                <van-col :span="12">
                  <span class="item-name">
                    桌台号： {{ item.TableNames }}
                  </span>
                </van-col>
                <van-col :span="12">
                  <span>用餐人数：{{ item.PersonCount }}</span>
                </van-col>
              </van-row>
              <van-row>
                <van-col :span="12" v-if="item.Contact">
                  <span>联系人：{{ item.Contact }}</span>
                </van-col>
                <van-col :span="12" v-if="item.Phone">
                  <span>电话：{{ item.Phone }}</span>
                </van-col>
              </van-row>
              <div>开台时间：{{ item.CheckInTime }}</div>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchPopup from "@/components/searchPopup";
import DataList from "@/components/DataList";
import restaurantManageApi from "@/api/restaurantManage.js";
// import { getSelectData } from "@/api/common";
import moment from "moment";
import { tag, Search, Tab, Tabs, Row, Col, Icon, Dialog } from "vant";
export default {
  name: "OrderPage",
  components: {
    DataList,
    [Search.name]: Search,
    [tag.name]: tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {},
  data() {
    return {
      getList: restaurantManageApi.getOrderPageAsync,
      params: {},
      keyword: "",
      tabName: "-1",
      swipeThreshold: 5,
      tabArr: [
        { name: "-1", title: "全部" },
        { name: "1", title: "用餐" },
        { name: "2", title: "结账" },
        { name: "12", title: "反结" },
        { name: "4", title: "取消" },
        { name: "0", title: "预订" },
        { name: "13", title: "待确认" },
      ],
      QueryTimeParam: "",
    };
  },
  model: {},
  created() {},
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    orderDetail(Id) {
      this.$router.push({
        name: "restarantManageOrderDetail",
        query: {
          orderId: Id,
        },
      });
    },
    changeTab(key) {
      this.params = {
        ...this.params,
        OrderStatus: key == -1 ? null : key,
      };
    },
    onSearch(/*val*/) {
      this.params = {
        ...this.params,
        No: this.keyword,
      };
    },
    onSearchClick() {
      searchPopup({
        title: "筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "时间类型",
            name: "QueryTimeParam",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: this.QueryTimeParam,
            },
            data: [
              {
                Id: "1",
                Text: "开台时间",
              },
              {
                Id: "2",
                Text: "结账时间",
              },
              {
                Id: "3",
                Text: "账务日期",
              },
            ],
          },
          {
            label: "订单日期",
            name: "datRange",
            type: "dateRange",
            props: {
              defaultValue: [],
            },
          },
        ],
        submit: values => {
          const json = {
            ...values,
          };

          if (values.dateRange) {
            json.StartDate = values.dateRange[0]
              ? moment(values.dateRange[0]).format("YYYY-MM-DD")
              : "";
            json.EndDate = values.dateRange[1]
              ? moment(values.dateRange[1]).format("YYYY-MM-DD")
              : "";
          }
          json.QueryTimeParam = values.QueryTimeParam
            ? values.QueryTimeParam
            : null;
          this.QueryTimeParam = json.QueryTimeParam;
          delete json.dateRange;
          this.params = {
            ...this.params,
            ...json,
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.res-order-list {
  height: calc(100vh - 195px);
  overflow: auto;
  .data-list /deep/.list-item {
    padding: 10px;
    line-height: 20px;
  }
}
</style>
